import * as React from 'react'
import Select from 'react-select'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

interface MultiSelectProps {
  name?: string
  placeholder?: string
  onChange?: (value: any) => void
  selectValue?: string
  options?: any
  tags?: any
  className?: string
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  name,
  placeholder,
  onChange,
  selectValue,
  options,
  tags,
  className,
}) => {
  const customStyles = {
    container: styles => ({
      ...styles,
      '&::after': {
        position: 'absolute',
        content: '""',
        background:
          'url(https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg) no-repeat',
        width: '1rem',
        height: '1rem',
        right: '1rem',
        top: '1rem',
        color: colors.black1,
      },
    }),
    control: (styles, value) => {
      return {
        ...styles,
        border: `1px solid ${colors.radagast}`,
        height: '2.75rem',
        color: colors.black1,
        fontSize: '0.875rem',
        borderRadius: '6px',
        width: '100%',
        padding: '0 1rem',
        boxShadow: 'none',
        borderColor: colors.radagast,
        cursor: 'pointer',
        marginBottom: value.hasValue ? '48px' : '0',
        '&:hover': {
          borderColor: colors.radagast,
        },
        '&.react-select__control--is-focused': {
          borderColor: colors.black1,
        },
      }
    },
    indicatorsContainer: styles => ({
      ...styles,
      display: 'none',
    }),
    valueContainer: (styles, value) => {
      return {
        ...styles,
        padding: '0',
        maxWidth: '97%',
        flexWrap: 'nowrap',
        position: value.hasValue ? 'absolute' : 'block',
        bottom: '-53px',
        left: '0',
      }
    },
    multiValue: styles => ({
      ...styles,
      height: '2.25rem',
      background: colors.black1,
      padding: '0 0.75rem',
      borderRadius: '4.375rem',
      alignItems: 'center',
      margin: '0 4px',
      '&:first-child': {
        marginLeft: '0',
      },
      '& > div': {
        color: 'white',
        fontSize: '0.875rem',
        lineHeight: '1.5rem',
        padding: '0',
      },
      '& > div.react-select__multi-value__remove': {
        padding: '0',
        background:
          'url(https://res.cloudinary.com/ninety-seconds/image/upload/v1599529886/Content%20Inspiration/icon-remove.svg) no-repeat center center',
        height: '18px',
        width: '18px',
        marginLeft: '0.25rem',
      },
      '& > div.react-select__multi-value__remove > svg': {
        display: 'none',
      },
      '& > div:hover': {
        color: 'white',
        backgroundColor: 'transparent',
      },
    }),
    menuList: styles => ({
      ...styles,
      boxShadow: '0 2px 8px rgb(0 0 0 / 15%)',
      borderRadius: '4px',
    }),
    menu: styles => ({
      ...styles,
      boxShadow: '0 2px 8px rgb(0 0 0 / 15%)',
      marginTop: '3px',
    }),
    option: styles => {
      return {
        ...styles,
        padding: '5px 12px',
        lineHeight: '22px',
        fontWeight: 'normal',
        color: 'rgba(0, 0, 0, 0.65)',
        background: '#FFF',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: '#1936D0',
          color: 'white',
        },
      }
    },
  }
  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={selectValue}
      isMulti
      styles={customStyles}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
    />
  )
}

export default MultiSelect



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardSettings/MultiSelect.tsx